import React from 'react';
import mapboxgl from 'mapbox-gl';

interface MapControlsProps {
  map: mapboxgl.Map;
}

const MapControls: React.FC<MapControlsProps> = () => {
  // Removed the duplicate navigation controls since they're already added in MapInitializer
  return null;
};

export default MapControls;